import {
	TopicHierarchySchema,
	ITopicHierarchy,
} from "@app/api/topics/helper-schemas";
import { store } from "index";
import {
	getDefaultStorageSettings,
	getDefaultReducer,
	filterByLoadTime,
	loadFromStorage,
	listenToLocalStorageChange,
} from "m-model-common";
import { getJoiObjectKeys, validateStorage } from "m-model-joi";
import { createModel, RawInstances, createCRUDActionTypes } from "m-model-core";
import { MAX_LOAD_TIME_DIFF_HIERARCHIES, MIN_LOAD_TIME } from "./constants";
import { CourseCommonMetaInfo } from "./meta-info";
import { ObjectId } from "@app/utils/generics";

const keyOfId = "_id";
type IdKey = typeof keyOfId;
type DOC = ITopicHierarchy;
export type IStateTopicHierarchies = RawInstances<IdKey, DOC>;

export type IPrerequisiteInfo = Record<string, ObjectId[] | undefined>;

// ==============Base Model=================

const dockeys = getJoiObjectKeys<DOC>(TopicHierarchySchema);
const storage = localStorage;
const actionTypes = createCRUDActionTypes("topicHierarchy");
const storageSettings = getDefaultStorageSettings("topicHierarchies");
const metaInformationName = "topicHierarchiesMetaInformation";

const isLoadedRecentlyEnough = filterByLoadTime(
	MAX_LOAD_TIME_DIFF_HIERARCHIES,
	MIN_LOAD_TIME
);

const Model = createModel<IdKey, DOC>({
	keyOfId,
	getInstances: (() => store.getState().topicHierarchies) as any,
	dispatch: (action => store.dispatch(action)) as any,
	subscribe: (listener => store.subscribe(listener)) as any,
	actionTypes,
	dockeys,
	loadInstancesFromStorage: () =>
		loadFromStorage({
			storage,
			key: storageSettings.itemName,
			validateWholeData: validateStorage(
				"ObjectId",
				TopicHierarchySchema
			),
			filter: isLoadedRecentlyEnough,
		}),
	indices: [{ fields: ["courseId"], unique: true }],
});

// ==============Main Model=================

export class TopicHierarchy extends Model {
	static initialize() {
		const info = super.initialize();
		if (info.loadedAll) this.meta.initialize();
		else this.meta.clear();
		return info;
	}

	static findOneByCourseSync(courseId: ObjectId) {
		return this.findOneSync({ courseId });
	}

	static meta = new CourseCommonMetaInfo(storage, metaInformationName);
}

export type ITopicHierarchyInstance = TopicHierarchy;
export type ITopicHierarchyModel = typeof TopicHierarchy;

// ==============ETC=================

listenToLocalStorageChange(storage, metaInformationName, TopicHierarchy.meta);

export const topicHierarchiesReducer = getDefaultReducer(
	storageSettings,
	() => TopicHierarchy
);
